function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { deviceMediaQueries } from '../../../../theme';
import { allCaps1Styles, allCaps3Styles } from '../../../typography/style';
import IconButton from '../../../icon-button';
import Typography from '../../../typography';
var commonCSS = /*#__PURE__*/css(["transition:130ms linear all;color:", ";overflow:hidden;text-overflow:ellipsis;position:absolute;width:100%;", ""], p => p.theme.colors.gray200, p => p.isActive && css(["", ";", "{", ";}"], allCaps3Styles, deviceMediaQueries.mobile, allCaps1Styles));

var getPaddingRightStyles = p => {
  if (p.hasInlinePlusMinusIconButtons) {
    return '70px';
  } else if (p.hasInlineIcon) {
    return '28px';
  } else {
    return '0';
  }
};

export var UnfocusedLabel = /*#__PURE__*/styled((_ref) => {
  var {
    isActive,
    textSizeMap,
    htmlFor,
    hasInlineIcon,
    hasInlinePlusMinusIconButtons
  } = _ref,
      props = _objectWithoutProperties(_ref, ["isActive", "textSizeMap", "htmlFor", "hasInlineIcon", "hasInlinePlusMinusIconButtons"]);

  return /*#__PURE__*/React.createElement("label", _extends({}, props, {
    htmlFor: htmlFor
  }));
}).withConfig({
  displayName: "style__UnfocusedLabel",
  componentId: "irqw3j-0"
})(["", ";padding-right:", ";", ";opacity:1;visibility:visible;", ""], commonCSS, p => getPaddingRightStyles(p), p => !p.isActive && "\n            ".concat(deviceMediaQueries.mobile, " {\n                font-size: ").concat(p.textSizeMap.mobile, "px;\n            }\n\n            ").concat(deviceMediaQueries.tablet, " {\n                font-size: ").concat(p.textSizeMap.tablet, "px;\n            }\n\n            ").concat(deviceMediaQueries.desktop, " {\n                font-size: ").concat(p.textSizeMap.desktop, "px;\n            }\n        "), p => p.isActive && css(["text-transform:none;visibility:hidden;opacity:0;font-size:14px;font-weight:400;top:1px;padding-right:0;"]));
export var FocusedLabel = /*#__PURE__*/styled((_ref2) => {
  var {
    isActive,
    textSizeMap,
    htmlFor
  } = _ref2,
      props = _objectWithoutProperties(_ref2, ["isActive", "textSizeMap", "htmlFor"]);

  return /*#__PURE__*/React.createElement("label", _extends({}, props, {
    htmlFor: htmlFor
  }));
}).withConfig({
  displayName: "style__FocusedLabel",
  componentId: "irqw3j-1"
})(["", ";", ";top:2px;opacity:0;visibility:hidden;text-transform:uppercase;", ""], commonCSS, p => !p.isActive && "\n            ".concat(deviceMediaQueries.mobile, " {\n                // .75 is used to generally match the width of the non-caps text\n                font-size: ").concat(p.textSizeMap.mobile * 0.75, "px;\n            }\n\n            ").concat(deviceMediaQueries.tablet, " {\n                font-size: ").concat(p.textSizeMap.tablet * 0.75, "px;\n            }\n\n            ").concat(deviceMediaQueries.desktop, " {\n                font-size: ").concat(p.textSizeMap.desktop * 0.75, "px;\n            }\n        "), p => p.isActive && css(["color:", ";opacity:1;visibility:visible;top:0;"], p.theme.colors.supplementBrandColor));
export var InfoIconFocusedLabelButton = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "style__InfoIconFocusedLabelButton",
  componentId: "irqw3j-2"
})(["transition:130ms linear margin,320ms linear visibility,320ms linear opacity;margin:0 8px 0 ", ";visibility:", ";opacity:", ";img{vertical-align:top;}"], p => p.isActive ? '8px' : '20px', p => p.isActive ? 'visible' : 'hidden', p => p.isActive ? 1 : 0);
export var InputLabelTypography = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "style__InputLabelTypography",
  componentId: "irqw3j-3"
})(["transition:130ms linear all;white-space:nowrap;pointer-events:none;position:absolute;width:100%;left:0;top:10px;", ""], p => p.isActive && css(["pointer-events:inherit;top:-13px;"]));